import { saveAs } from "file-saver";
import moment from "moment";

// Làm sạch tên file theo NỘI DUNG (giữ tiếng Việt có dấu): bỏ ký tự cấm trên Windows/macOS
// (\ / : * ? " < > |) và ký tự điều khiển, gọn khoảng trắng, cắt bớt độ dài. Rỗng → fallback.
// KHÔNG kèm đuôi .xlsx (nơi gọi tự thêm).
export const sanitizeFileName = (name?: string, fallback = "Báo cáo"): string => {
  const cleaned = (name ?? "")
    // eslint-disable-next-line no-control-regex
    .replace(/[\\/:*?"<>|\x00-\x1f]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 150);
  return cleaned || fallback;
};

// Tên file tiếng Việt kèm hậu tố ngày giờ (dd-MM-yyyy HHmm), vd "Bảng tổng hợp khoản thu 28-07-2026 1530".
// Không kèm đuôi mở rộng (nơi gọi tự thêm ".xlsx").
export const fileNameWithTime = (name?: string, fallback = "Báo cáo"): string =>
  `${sanitizeFileName(name, fallback)} ${moment().format("DD-MM-YYYY HHmm")}`;

export const Download = {
  Excel: (data: string, name_file: string) => {
    const base64Data = data;
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(undefined)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, name_file);
  },
  Pdf: (data: string, name_file: string) => {
    const base64Data = data.replace(/^data:application\/pdf;base64,/, ""); // Loại bỏ prefix nếu có
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(undefined)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: "application/pdf" });
    saveAs(blob, name_file);
  },
};
